/* Focus decoration follows input modality without changing focus behavior. */
(() => {
  if (window.__dspFocusModalityReady) return;
  window.__dspFocusModalityReady = true;

  const root = document.documentElement;
  const navigationKeys = new Set([
    'Tab', 'Enter', ' ', 'Spacebar', 'Escape',
    'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
    'Home', 'End', 'PageUp', 'PageDown'
  ]);

  root.dataset.dspFocus = 'pointer';

  document.addEventListener('pointerdown', () => {
    root.dataset.dspFocus = 'pointer';
  }, true);

  document.addEventListener('keydown', (event) => {
    // Cmd/Ctrl-click and browser shortcuts must not leave a keyboard ring.
    if (event.metaKey || event.ctrlKey || event.altKey || !navigationKeys.has(event.key)) return;
    const target = event.target;
    const textInput = target?.tagName === 'INPUT'
      && !['button', 'checkbox', 'radio', 'submit', 'reset', 'file', 'image', 'range', 'color'].includes(target.type);
    const textEntry = textInput || target?.tagName === 'TEXTAREA'
      || target?.isContentEditable || target?.closest?.('[contenteditable]:not([contenteditable="false"])');
    // Space, arrows and Enter edit text; Tab still moves between controls.
    if (event.key !== 'Tab' && textEntry) return;
    root.dataset.dspFocus = 'keyboard';
  }, true);
})();
